<nav class="navi" *ngIf="navbarService.showNavbar">
    <div class="nav-container pt-3 pb-2 container-lg">
        <!-- logo and hamburger icon -->
        <div class="logo-container pb-1">
            <a [routerLink]="['']"><img src="../../assets/images/logo.png" alt="logo"
                    class="img-fluid d-block me-auto" /></a>
            <button class="h1 bg-transparent border-0" (click)="pannelToggle()">
                <i class="bi bi-list"></i>
            </button>
        </div>
        <!-- navigation links and buttons -->
        <div class="links-container">
            <a [routerLink]="['/features']">Функционалност</a>
            <a [routerLink]="['/about']">За приложението</a>
        </div>
        <div class="button-container">
            <button class="btn-login btn" [routerLink]="['/login']">Вписване</button>
            <button class="btn-register btn btn-outline-dark" [routerLink]="['/login']"
                [queryParams]="{ variable: register }">Регистрация</button>
        </div>

        <!-- side pannel navigation -->
        <div class="side-pannel-container" [ngClass]="isShowPannel ? 'show-pannel' : ''">
            <!-- side pannel on smaller devices -->
            <div class="side-pannel card" [ngClass]="isShowPannel ? 'show-side-pannel' : ''">
                <button class="h1 close-btn" (click)="pannelToggle()">
                    <i class="bi bi-x-lg"></i>
                </button>
                <div class="links-container-side">
                    <!-- dropdown menu 1 -->
                    <a [routerLink]="['/features']" style="margin-bottom: 1.8rem">Функционалност</a>
                    <a [routerLink]="['/about']" style="margin-bottom: 1rem">За приложението</a>
                </div>
                <div class="button-container-side">
                    <button class="login-btn btn mb-3 fw-500" style="font-weight: 500" [routerLink]="['/login']">
                        Вписване
                    </button>
                    <button class="register-btn btn btn-outline-dark" [routerLink]="['/login']"
                        [queryParams]="{ variable: register }">Регистрация</button>
                </div>
            </div>
        </div>
    </div>